<template>
  <div>
    <a-form-model
      layout="inline"
      :model="form"
      ref="queryForm"
      style="margin-left:10px"
    >
      <a-row :gutter="24">
        <a-form-model-item
          v-for="(item, index) in DataList"
          :key="index"
          :prop="item.key"
        >
          <a-input
            style="width: 200px"
            allowClear
            v-model="form[item.key]"
            :placeholder="item.placeholder"
            v-if="item.type == 'input'"
          ></a-input>

          <a-textarea
            allowClear
            v-model="form[item.key]"
            :placeholder="item.placeholder"
            :rows="2"
            v-if="item.type == 'textarea'"
          ></a-textarea>

          <a-form-model-item
            :prop="item.key"
            :label="item.placeholder"
            v-if="item.type == 'ChangeSelect'"
            style="width: 200px;margin: 0"
          >
            <a-radio-group v-model="form[item.key]">
              <a-radio :value="form[item.key]">{{ form[item.key] }}</a-radio>
            </a-radio-group>
            <a-button
              :hidden="isReadOnly"
              type="primary"
              @click="handleChangeSelect"
            >选择</a-button>
          </a-form-model-item>
          <a-select
            allowClear
            v-model="form[item.key]"
            :placeholder="item.placeholder"
            v-if="item.type == 'select' && !item.hasOwnProperty('childrenKey')"
            @change="changeDataSel($event,item)"
            style="width: 200px"
          >
            <a-select-option
              v-for="item2 in options[item.selectName]"
              :key="
                item2.dicId ? item2.dicId : item2.ctId ? item2.ctId : item2.id
              "
              :value="
                item2.dicId ? item2.dicId : item2.ctId ? item2.ctId : item2.id
              "
              :title="item2.name ? item2.name : item2.ctName"
            >
              {{ item2.name ? item2.name : item2.ctName }}
            </a-select-option>
          </a-select>

          <a-select
            allowClear
            v-model="form[item.key]"
            :placeholder="item.placeholder"
            v-if="
              item.type == 'select' &&
                item.hasOwnProperty('childrenKey') &&
                checkPermission(item.isAuth)
            "
            style="width: 200px"
            @change="ChangeSelect($event,item)"
          >
            <a-select-option
              v-for="item2 in options[item.selectName]"
              :key="item2.PROVINCEID ? item2.PROVINCEID : item2.orgId"
              :value="item2.PROVINCEID ? item2.PROVINCEID : item2.orgId"
            >
              {{
                item2.PROVINCENAME
                  ? item2.PROVINCENAME
                  : item2.areaName
                  ? item2.areaName
                  : item2.orgName
              }}
            </a-select-option>
          </a-select>

          <a-date-picker
            allowClear
            v-if="item.type == 'date'"
            :locale="DatePickerLocalCN"
            style="width: 200px"
            v-model="form[item.key]"
            :show-time="{ format: item.format }"
            :format="item.format"
            :value-format="item.format"
            :placeholder="item.placeholder"
          />

          <a-range-picker
            allowClear
            v-if="item.type == 'rangedate'"
            :show-time="item.showTime"
            :locale="DatePickerLocalCN"
            style="width: 300px"
            v-model="form[item.key]"
            :format="item.format"
            :value-format="item.format"
            :placeholder="item.placeholder"
          />
          <!-- // 下拉框支持搜索 -->
          <a-select
            allowClear
            v-if="item.type == 'searchSelect'"
            show-search
            :placeholder="item.placeholder"
            option-filter-prop="children"
            v-model="form[item.key]"
            style="width: 200px"
            :filter-option="filterOption"
            @focus="handleFocus"
            @blur="handleBlur"
            @change="handleChange"
          >
            <a-select-option
              v-for="item2 in options[item.selectName]"
              :key="
                item2.dicId ? item2.dicId : item2.ctId ? item2.ctId : item2.id
              "
              :value="
                item2.dicId ? item2.dicId : item2.ctId ? item2.ctId : item2.id
              "
              :title="item2.name ? item2.name : item2.ctName"
            >
              {{ item2.name ? item2.name : item2.ctName }}
            </a-select-option>
          </a-select>
          <a-tree-select
            style="width: 200px"
            allowClear
            v-if="item.type == 'treeSelect'"
            :placeholder="item.placeholder"
            v-model="form[item.key]"
            tree-data-simple-mode
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="options[item.selectName]"
            :load-data="onLoadData"
            @change="tressSelect"
            @focus="treeFocus(item.selectName)"
          />


          <a-tree-select
            style="width: 200px"
            v-model="form[item.key]"
            v-if="item.type == 'treeSelectSearch'"
            show-search
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :placeholder="item.placeholder"
            treeNodeFilterProp="title"
            labelInvalue
            allow-clear
            @change="tressSelect"
            @focus="treeFocus(item.selectName)"
          >
            <a-tree-select-node v-for="(vv,ii) in options[item.selectName]" :key="ii" :value="vv.subjectId ? vv.subjectId : vv.majorId" :title="vv.name">
              <a-tree-select-node v-for="(item2,index2) in vv.children" :key="ii +'-'+index2" :value="item2.subjectId ?item2.subjectId : item2.majorId" :title="item2.name">
                <a-tree-select-node v-for="(item3,index3) in item2.children" :key="ii+'-'+index2+'-'+index3" :value="item3.subjectId ?item3.subjectId : item3.majorId" :title="item3.name" />
              </a-tree-select-node>
            </a-tree-select-node>
          </a-tree-select>


        </a-form-model-item>

<!--        <div class="Search-box">-->
<!--          <div class="Search-left">-->
<!--            <a-form-model-item>-->
<!--              <table-btn-group-->
<!--                v-bind="$attrs"-->
<!--                v-on="$listeners"-->
<!--                :style="{ marginLeft: '8px', display: 'inline' }"-->
<!--              />-->
<!--            </a-form-model-item>-->
<!--          </div>-->
<!--          <div class="Search-right">-->
<!--            <a-form-model-item>-->
<!--              <a-button-->
<!--                :style="{ marginLeft: '8px' }"-->
<!--                type="primary"-->
<!--                @click="handleSearch"-->
<!--              >查 询</a-button-->
<!--              >-->
<!--              <a-button-->
<!--                :style="{ marginLeft: '8px' }"-->
<!--                @click="handleReset"-->
<!--                style="color:#7a4b51"-->
<!--              >重 置</a-button-->
<!--              >-->
<!--              &lt;!&ndash;              <a-button&ndash;&gt;-->
<!--              &lt;!&ndash;                :style="{ marginLeft: '8px', fontSize: '12px' }"&ndash;&gt;-->
<!--              &lt;!&ndash;                @click="toggle"&ndash;&gt;-->
<!--              &lt;!&ndash;              >&ndash;&gt;-->
<!--              &lt;!&ndash;                {{ word }}&ndash;&gt;-->
<!--              &lt;!&ndash;                <a-icon :type="!showAll ? 'up' : 'down'" />&ndash;&gt;-->
<!--              &lt;!&ndash;              </a-button>&ndash;&gt;-->
<!--            </a-form-model-item>-->
<!--          </div>-->
<!--        </div>-->
      </a-row>
    </a-form-model>
    <use-modal
      :modal-visible="modalVisible"
      :is-read-only="isReadOnly"
      :dis-block="disBlock"
      :ok-text="okText"
      :modal-title="modalTitle"
      :modal-width="modalW"
      :modal-height="modalH"
      @handleCancel="modalCancel"
      @handleOk="handleSubmit"
    >
      <component
        ref="ModleForm"
        :is="comName"
        :data="data"
        :is-read-only="isReadOnly"
      ></component>
    </use-modal>
  </div>
</template>

<script>
import DatePickerLocalCN from "@/utils/TimeDate.js";
import TableBtnGroup from "./TableBtnGroup.vue";
import UseModal from "@/components/UseModal.vue";
import * as allType from "@/config/typeConfig";
import UseTable from "@/components/UseTable.vue";
import {allSubject, violationsReasonLim} from "../config/typeConfig";

const SelectConfirmPoint = {
  data() {
    return {
      tableHeaderModel: [
        {
          dataIndex: "orgName",
          title: "确认点"
        },
        {
          dataIndex: "confirmRange",
          title: "确认范围"
        }
      ],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      }
    };
  },
  props: {
    data: {
      type: Array,
      default: []
    }
  },
  components: {
    UseTable
  },
  template: `
                  <div>
                        <a-form-model layout="inline"  ref="ModleForm">
                          <a-row :gutter="24">
                            <a-form-model-item v-bind="formItemLayout" style="width: 40%;margin-left: 10px;margin-bottom: 10px">
                              <a-input placeholder="请输入需要搜索的确认点"  />
                            </a-form-model-item>
                            <a-form-model-item v-bind="formItemLayout">
                              <a-button
                                :style="{ marginLeft: '8px' }"
                                type="primary"
                                @click="handleSearch"
                              >查 询</a-button >
                            </a-form-model-item>
                          </a-row>
                        </a-form-model>
                         <use-table
  :current="page" :isPage="false" :data="data" ref="useTable" :tableHeaderModel="tableHeaderModel" @rowEvent="rowEvents" >
                    </use-table>
                  </div>
                  `,
  methods: {
    getSelectdata() {
      const data = this.$refs.useTable.tableSelectArr;
      return data;
    },

    handleSearch() {},
    rowEvents() {}
  }
};

export default {
  name: "ChangeForm2",
  props: {
    // formVal: {
    //   type: Object,
    //   default: {}
    // },
    chgDataList: {
      type: Array,
      default: []
    }
  },
  components: {
    DatePickerLocalCN,
    UseModal,
    TableBtnGroup,
    SelectConfirmPoint
  },
  data() {
    return {
      // 弹框所需参数
      modalVisible: false,
      isReadOnly: false,
      disBlock: true,
      isAdd: false,
      okText: "确定",
      modalTitle: "",
      modalW: 980,
      modalH: "auto",
      comName: "",


      ChangeRecordForm: {},
      options: {
        allSubject: undefined,
        teaSubject:undefined
      },
      selectTreeType: "",
      data: [],

      subjectData: [],
      ctList: [],
      nationList: [],
      idTypeList: [],
      DatePickerLocalCN,
      DataList: [],
      form: {
        subject:undefined,
        teaSubject:undefined
      },
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 10 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 14 }
        }
      }
    };
  },
  watch: {
    chgDataList: {
      handler: function(val) {
        console.log(val);



      },
      immediate: true
    }
  },
  mounted() {
    this.setData();
    // this.DataList = this.chgDataList;
    // console.log(this.chgDataList, "数据的来源");
    // this.loadSelectData(this.DataList);
  },
  methods: {
    setData(){
      this.DataList = this.chgDataList;
      this.loadSelectData(this.DataList);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChange(e) {},
    handleFocus() {},
    handleBlur(e) {},
    rowEvents(obj) {
      this[obj.method](obj.row, obj.num);
    },

    handleSubmit() {
      let data = this.$refs.ModleForm.getSelectdata();
      this.modalCancel(false);
      this.form.areaName = data[0].areaName;
      this.form.localeId = data[0].orgId;
    },

    changeDataSel(val,data){
      console.log(val,data);
      if(data.selectName === 'ctId'){
        if(val == undefined){
          this.options.allSubject=[];
          this.$set(this.form, "subject", undefined);
          return false;
        }
        allType["allSubject"](this, { subjectType: val}).then(res => {
          this.options.allSubject  = res;
          this.$set(this.form, "subject", undefined);
          this.$forceUpdate();
        });
      } else if(data.selectName === 'teaGrade' && data.key == 'teaGrade'){
        if(val == undefined){
          this.options.teaSubject=[];
          this.$set(this.form, "teaSubject", undefined);
          return false
        }
        allType["allSubject"](this, { subjectType: val}).then(res => {
          this.options.teaSubject  = res;
          this.$set(this.form, "teaSubject", undefined);
          this.$forceUpdate();
        });
      }
      else if (data.selectName === 'violationsTypeLim') {
        allType["violationsLim"](this, {pId: val}).then(res => {
          this.options.violationsLim = res;
          this.$set(this.form, "violationsLim", undefined);
          this.$forceUpdate();
        });
      } else if (data.selectName === 'violationsLim') {
        allType["violationsReasonLim"](this, {pId: val}).then(res => {
          this.options.violationsReasonLim = res;
          this.$set(this.form, "violationsReasonLim", undefined);
          this.$forceUpdate();
        });
      }
    },

    handleChangeSelect() {
      this.modalTitle = "选择";
      this.okText = "确定";
      this.isReadOnly = false;
      this.disBlock = true;
      this.$json("queryBaseOrgEnrollBasic", {
        status: 1,
        parentId: JSON.parse(sessionStorage.getItem("unInfo")).user.orgId
      }).then(response => {
        this.data = response.record;
        this.modalVisible = true;
        this.setComName("SelectConfirmPoint", this.modalW);
      });
    },
    setComName(comName, modalW) {
      this.modalW = modalW;
      this.comName = comName;
    },

    modalCancel(bool) {
      // this.$refs.ModleForm.$children[0].resetFields();
      this.comName = "SelectConfirmPoint";
      this.modalVisible = bool;
      this.isReadOnly = false;
      this.disBlock = true;
    },
    // 选择省市联动
    ChangeSelect(event,data) {
      if (data.key == "county") {
        return false;
      }
      // const val = this.form.province && this.form.city ? this.form.city : this.form.province ;
      // console.log(this.form.province);
      this.queryArea(event, data.childrenKey, data.selectName);
    },

    async queryArea(parentId, type, selectName) {
      let orgType = type == "city" ? 3 : type == "county" ? 2 : 4;
      const query = {
        url: "queryBaseOrgBasic",
        params: {
          parentId: parentId,
          orgType: orgType
        }
      };
      const data = await allType[query.url](this, query.params);
      if ("city" == type) {
        this.$set(this.form, "city", undefined);
        this.$set(this.form, "county", undefined);
        this.options["getCityBasic"] = data;
        console.log(this.options, "//");
      } else if ("county" == type) {
        this.$set(this.form, "county", undefined);
        this.options["getcountyBasic"] = data;
      }
      this.$forceUpdate();
    },
    handleSearch() {
      // this.form.queryData = this.queryData;
      // this.getUserType();
      this.$emit("handle-search", this.form);
    },

    handleGetSearchForm() {
      return this.form

    },
    handleReset() {
      const refs = this.$refs.queryForm;
      refs.resetFields();
      this.$emit("handle-search", this.form);
    },
    clearFieldsVal(){
      const refs = this.$refs.queryForm;
      refs.resetFields();
    },
    treeFocus(selectName) {
      this.selectTreeType = selectName;
    },
    async loadSelectData(n) {
      let form = {};
      for (const el of n) {
        const user = JSON.parse(sessionStorage.getItem("unInfo")).user;
        let orgId = String(user.orgId);
        let orgType = user.orgType;
        if (el.type === "select" || el.type === "treeSelect" || el.type === "searchSelect" || el.type === "treeSelectSearch") {
          if (el.hasOwnProperty("childrenKey") && orgType == 4) {
            this.queryArea(orgId, "city");
            continue;
          } else if (el.hasOwnProperty("childrenKey") && orgType == 3) {
            this.queryArea(orgId, "county");
            continue;
          }
          form[el.key] = undefined;
          this.options[el.selectName] = [];
          const isFun = typeof allType[el.selectName] === "function";
          if (isFun) {

            if(el.isload !=1){
              const ChangeData = await allType[el.selectName](this, el.params);
              if (el.hasOwnProperty("optionsKey")) {
                el.selectName = el.optionsKey;
              }
              this.options[el.selectName] = ChangeData;
            }

          } else {
            this.options[el.selectName] = await allType[el.selectName];
          }
          this.$forceUpdate();
        } else {
          form[el.key] = "";
        }
      }
      this.form = form;
    },

    onLoadData(treeNode) {
      const eventKey = treeNode.eventKey;
      const index = eventKey.toString().lastIndexOf("-") + 1;
      const key = treeNode.eventKey.toString().substring(index);
      return new Promise(resolve => {
        setTimeout(() => {
          allType[this.selectTreeType](this, { parentId: key }).then(res => {
            const subjectData = this.options[this.selectTreeType].concat(res);
            let options = this.options;
            this.$set(options, this.selectTreeType, subjectData);
            this.$forceUpdate();
          });
          resolve();
        }, 100);
      });
    },
    tressSelect: function(node, e) {
      this.form[this.selectTreeType] = node;
    }


  }
};
</script>

<style lang="less" scoped>
#searchBox {
  overflow: hidden;
}
.Search-box {
  width: 100%;
  text-align: right;
  .Search-left {
    float: left;
  }
  .Search-right {
    float: right;
  }
}

.ant-form-item {
  margin-bottom: 8px;
}
.query-form {
  .ant-form {
    max-width: none;

    /deep/ .ant-form-item {
      display: flex;
      margin-bottom: 8px;
      .ant-form-item-control-wrapper {
        flex: 1;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/SearchNoButtonForm.vue